export default "__VITE_ASSET__a3543536__"